<template lang="pug">
.v-grid-banner.grid-banner(
	v-if="banner"
	:class="`grid-banner--${banner.color}`"
	:id="id"
)
	.grid-banner__container.container
		.grid-banner__wrap
			.grid-banner__left
				.grid-banner__supertitle(v-if="banner.supertitle")
					v-svg-icon.grid-banner__supertitle-icon(:icon="banner.icon || 'flower'")
					.grid-banner__supertitle-text {{banner.supertitle}}
				h2.grid-banner__title.flc(v-if="banner.title" v-html="banner.title")
				.grid-banner__subtitle.flc(v-if="banner.subtitle")
					.grid-banner__subtitle-text {{banner.subtitle}}
				.grid-banner__text.flc(v-if="banner.text") {{banner.text}}
				.grid-banner__action.flc(v-if="banner.link")
					a.grid-banner__link.btn.btn--primary-2.btn--has-right-icon(:href="banner.link.link" :class="{'btn--wide': isMd}")
						.btn__text {{banner.link.text}}
						.btn__icon-wrap
							v-svg-icon.btn__icon.btn__icon--original(icon="arrow-top-right")
							v-svg-icon.btn__icon.btn__icon--copy(icon="arrow-top-right")
				.grid-banner__article(v-if="banner.article && !isMd")
					.grid-banner__article-title(v-if="banner.article.title") {{banner.article.title}}
					.grid-banner__article-text(v-if="banner.article.text" v-html="decodeHtmlRegex(banner.article.text)" )
			.grid-banner__right(v-if="banner.items && banner.items.length && banner.itemsType === 'inline'")
				.grid-banner__items
						.grid-banner__col.grid-banner__col--narrow.flc(v-if="banner.items")
							.grid-banner__item(
								v-for="(item, index) in banner.items"
								:key="index"
								:class="`grid-banner__item--${item.color}`"
								@click="clickToBannerItem(item, index)"
							)
								img.grid-banner__item-image(v-if="item.image" :src="item.image")
								.grid-banner__item-title(v-if="item.title") {{item.title}}
								.grid-banner__item-text(v-if="item.text" v-html="item.text")
								.grid-banner__item-icon-wrap(v-if="item.icon" :class="{'grid-banner__item-icon-wrap--transparent': item.image}")
									v-svg-icon.grid-banner__item-icon(:icon="item.icon")

			.grid-banner__right(v-else-if="banner.items")
				v-banner-grid(:items="banner.items")
			.grid-banner__right.content.text-guide(v-else-if="banner.content" v-html="banner.content")
			.grid-banner__right(v-else-if="banner.accordion")
				v-accordion.info-banner__accordion(:items="banner.accordion")


			.grid-banner__right.grid-banner__col--narrow-alt(v-if="banner.columnList")
				.bg-banner__list.flc(v-if="banner.columnList")
					.bg-banner__list-item(v-for="(item, index) in banner.columnList" :key="index" )
						.bg-banner__list-item-left
							.grid-banner__item-icon-wrap.static(v-if="item.icon" :class="{'grid-banner__item-icon-wrap--transparent': item.image}")
								v-svg-icon.grid-banner__item-icon(:icon="item.icon")
							.grid-banner__item-icon-wrap.static.numeratic(v-else-if="!item.icon" :class="{'grid-banner__item-icon-wrap--transparent': item.image}")
								.grid-banner__item-number 0{{ index+1 }}
							.bg-banner__list-item_title(v-if="item.title" v-html="item.title")
						.bg-banner__list-item_text(v-if="item.text") {{item.text}}

			.grid-banner__article(v-if="banner.article && isMd")
				.grid-banner__article-title(v-if="banner.article.title") {{banner.article.title}}
				.grid-banner__article-text(v-if="banner.article.text" v-html="decodeHtmlRegex(banner.article.text)" )
</template>

<script>
import sourceMixin from '../components/mixins/v-mixin-source.vue';
import isMobMixin from '../components/mixins/v-mixin-is-mob.vue';
import controller from "../scripts/controller/controller.js";
import VBannerGrid from "./v-banner-grid.vue";
import {useRouter} from "vue-router";

export default {
	components: {VBannerGrid},
	mixins: [
		sourceMixin,
		isMobMixin
	],

	data() {
		return {
			banner: null,
			id: null
		};
	},

	mounted() {
		if (this.banner) {

		}
		controller.goToLink();

		setTimeout(() => {
			const route = window.location;
			this.id = route.pathname.includes('/meat') ? 'eco' :''
		})
	},

	unmounted() {
		window.removeEventListener('scroll', this.handleScroll);
	},

	methods: {
		handleScroll() {
			const logoHeight = 80;
			const logoOffset = 48;
			if (window.scrollY > this.$el?.offsetTop - 48 && (window.scrollY < this.$el?.offsetHeight + this.$el?.offsetTop + logoHeight - logoOffset)) {
				// document.body.classList.add('state--page-header-blackout');
			}
		},

		clickToBannerItem(item, index) {
			const targetId = item.tab_id || item.link || `${index+1}`;


			if (targetId) {
				controller.goToLink(targetId);
			}
		},

		dataSet(data) {
			this.banner = data;
			this.handleScroll();
			console.log(data)

			const route = window.location;
			const iconsForMainPage = ['molecule', 'grand', 'handshake', 'buld'];
			const iconsForCandyPage = ['hand', 'cheese-6', 'tech', 'pallet'];

			if (route.pathname === '/') {
				this.banner.items.map((item, index) => {
					item.icon = iconsForMainPage[index];
				});
			}

			if (route.pathname.includes('/candy')) {

				this.banner.items.map((item, index) => {
					item.icon = iconsForCandyPage[index];
				});
			}

			window.addEventListener('scroll', this.handleScroll, controller.passiveEventsSupported ? {passive: true} : undefined);
		},

		decodeHtmlRegex(str) {
			const entities = {
				'&amp;': '&',
				'&lt;': '<',
				'&gt;': '>',
				'&quot;': '"',
				'&#39;': "'",
				'&#x27;': "'"
			};
			return str.replace(/&[a-z0-9#x]+;/gi, match => entities[match] || match);
		}
	}
};
</script>
